import { create } from "zustand";
import questionMappingService from "../services/questionMappingService";
import exerciseResultService from "../services/exerciseResultService";

const useDoExerciseStore = create((set) => ({
  answers: [],
  questions: [],
  exercise_id: null,
  isDirty: false,
  count_done: 0,
  error: null,
  result: null,
  isLoading: false,


  fetchQuestions: async (exercise_id) => {
    set({exercise_id: exercise_id})
    try {
      const questions = await questionMappingService.getMappingByExerciseId(exercise_id)
      const answerTemplate = questions.data.map(question => ({
        question_id: question.question_id,
        answer: ""
      }))
      set({questions: questions.data,answers: answerTemplate,isDirty: false,
        count_done: 0,
        error: null,
        result: null,
        isLoading: false,  })

    } catch (error) {
      console.error(error)
    }
  },
  // newAnswer: { answer: string, question_id: string }
  addAnswer: (newAnswer) => {

    const { answers} = useDoExerciseStore.getState()
    const oldAnswer = answers.find(item => item.question_id === newAnswer.question_id)
    console.log(newAnswer,answers)
    console.log(oldAnswer)

    let count_done = answers.filter(answer => answer.answer!=="").length
    if (oldAnswer.answer==="") count_done++
    oldAnswer.answer = newAnswer.answer

    set({answers: answers, isDirty: true, count_done: count_done})
  },

  checkDone: () => {
    const { answers} = useDoExerciseStore.getState()
    const isDone = !answers.find(answer => answer.answer === "")
    return isDone
  },

  submit: async () => {
    try {
      set({isLoading: true})
      const { exercise_id,count_done, answers} = useDoExerciseStore.getState()
    if (count_done===answers.length) {
      // handle submit
      const response = await exerciseResultService.scoreExercise({
        answers,
        exercise_id
      })
      set({result:response.data })
      setTimeout(() => {
        set({isLoading: false})
      }, 2000);
    }
    else {
      alert("Vui lòng hoàn thành toàn bộ trước khi nộp bài!")
      set({error: "Vui lòng hoàn thành toàn bộ trước khi nộp bài!"})
    }
    } catch (error) {
      console.error(error)
    }
    finally {
      set({isLoading: false})
    }


  },

  submitWriting: async () => {
    try {
      set({isLoading: true})
      const { exercise_id,count_done, answers} = useDoExerciseStore.getState()
      if (count_done===answers.length) {
        // handle submit
        const response = await exerciseResultService.scoreExerciseWriting({
          answer: answers[0].answer,
          exercise_id,
          question_id: answers[0].question_id

        })
        set({result:response.data })
        setTimeout(() => {
          set({isLoading: false})
        }, 2000);
      }
      else {
        alert("Vui lòng hoàn thành toàn bộ trước khi nộp bài!")
        set({error: "Vui lòng hoàn thành toàn bộ trước khi nộp bài!"})
      }
    } catch (error) {

    }
  },

  redo: async () => {
    window.location.reload()
    set({ result: null, isDirty: false, answers: [], count_done: 0, error: null})

    const { fetchQuestions, exercise_id} = useDoExerciseStore.getState()
    await fetchQuestions(exercise_id)
  }
}))

export default useDoExerciseStore;
